import React, { useState } from 'react';
import '../styles/Header.css';
import scroll from '../assets/images/scroll-down.png';

const JumpLink = () => {
    const [isHovered, setIsHovered] = useState(false);

    const scrollToSection = () => {
        window.scrollTo({
            top: document.documentElement.clientHeight - 40, // Adjust this value to the target section's offset
            behavior: 'smooth',
        });
    };

    return (
        <a
            href="#"
            className = "jump-link"
            onClick={(e) => {
                e.preventDefault();
                scrollToSection();
            }}
            style={{color: 'white'}}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            rel='noreferrer'
        >
            <span>
                Hop on
            </span>
            <img
                src={scroll}
                alt="Scroll Down"
            />
        </a>
    );
};

export default JumpLink;